<script lang="ts">
  export let layout: "vertical" | "horizontal" = "vertical"
  export let gap: "2xs" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "none" =
    "lg"
  export let justifyContent:
    | "start"
    | "center"
    | "end"
    | "space-between"
    | "space-around"
    | "space-evenly"
    | "normal" = "normal"
  export let alignItems:
    | "start"
    | "center"
    | "end"
    | "stretch"
    | "baseline"
    | "normal" = "normal"
  export let wrap: "wrap" | "nowrap" | "wrap-reverse" = "nowrap"
</script>

<div
  class="au-stack"
  data-layout={layout}
  data-gap={gap}
  data-wrap={wrap}
  data-justify-content={justifyContent}
  data-align-items={alignItems}
  {...$$restProps}
>
  <slot />
</div>

<style>
  .au-stack {
    --au-stack-gap: 0;

    display: flex;
    gap: var(--au-stack-gap);
  }

  .au-stack[data-layout="vertical"] {
    flex-direction: column;
  }

  .au-stack[data-layout="horizontal"] {
    flex-direction: row;
  }

  .au-stack[data-gap="2xs"] {
    --au-stack-gap: var(--au-spacing-2xs);
  }

  .au-stack[data-gap="xs"] {
    --au-stack-gap: var(--au-spacing-xs);
  }

  .au-stack[data-gap="sm"] {
    --au-stack-gap: var(--au-spacing-sm);
  }

  .au-stack[data-gap="md"] {
    --au-stack-gap: var(--au-spacing-md);
  }

  .au-stack[data-gap="lg"] {
    --au-stack-gap: var(--au-spacing-lg);
  }

  .au-stack[data-gap="xl"] {
    --au-stack-gap: var(--au-spacing-xl);
  }

  .au-stack[data-gap="2xl"] {
    --au-stack-gap: var(--au-spacing-2xl);
  }

  .au-stack[data-justify-content="start"] {
    justify-content: flex-start;
  }

  .au-stack[data-justify-content="center"] {
    justify-content: center;
  }

  .au-stack[data-justify-content="end"] {
    justify-content: flex-end;
  }

  .au-stack[data-justify-content="space-between"] {
    justify-content: space-between;
  }

  .au-stack[data-justify-content="space-around"] {
    justify-content: space-around;
  }

  .au-stack[data-justify-content="space-evenly"] {
    justify-content: space-evenly;
  }

  .au-stack[data-align-items="start"] {
    align-items: flex-start;
  }

  .au-stack[data-align-items="center"] {
    align-items: center;
  }

  .au-stack[data-align-items="end"] {
    align-items: flex-end;
  }

  .au-stack[data-align-items="stretch"] {
    align-items: stretch;
  }

  .au-stack[data-align-items="baseline"] {
    align-items: baseline;
  }

  .au-stack[data-wrap="nowrap"] {
    flex-wrap: nowrap;
  }

  .au-stack[data-wrap="wrap"] {
    flex-wrap: wrap;
  }

  .au-stack[data-wrap="wrap-reverse"] {
    flex-wrap: wrap-reverse;
  }
</style>
